/**
 * @author lifei
 * 功能：库存中心
 */

import * as func from '@/func'
const enumToList = func.enumToList()
/**
 * 功能：单据类型 map（1-组合单，2-拆套单）
 */
export enum MapCsFormType {
  组合单 = 1,
  拆套单 = 2,
}
/**
 * 功能：单据类型 list
 */
export const ListCsFormType = enumToList({ MapCsFormType })

/**
 * 功能：执行状态 map(1-待执行，2-执行完成)
 */
export enum MapExecuteStatus {
  待执行 = 1,
  已执行 = 2,
}

/**
 * 功能：执行状态 list(1-待执行，2-执行完成)
 */
export const ListExecuteStatus = enumToList({ MapExecuteStatus })
